// extracted by mini-css-extract-plugin
export var breadcrumbsContainer = "vbKumI83";
export var breadcrumb = "FOI9WgSl";
export var arrow = "c+m2uihS";
export var currentPage = "_27HRvdfb";